// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"d55bae0c","208":"3a502dce","374":"a4733e29","438":"9f65a26e","507":"35dae70e","801":"217b0b92","961":"ae6d75c4"}[chunkId] + ".chunk.js";
};